import type { MisconceptionDefinition } from '../types'

export const GET_BASIS: MisconceptionDefinition[] = [
  {
    id: 'get.place-value-swap',
    label: 'Plaatswaarde verwisseld',
    module: 'Getalbegrip',
    description:
      'Leerling verwisselt tientallen en eenheden, of honderdtallen en tientallen.',
    typicalFamilies: ['GET-GROOT-LEZEN', 'GET-GROOT-POS'],
  },
  {
    id: 'get.vergelijk-honderdtallen-genoeg',
    label: 'Stopt bij honderdtallen — vergelijkt niet door',
    module: 'Getalbegrip',
    description:
      'Leerling vergelijkt alleen de honderdtallen en stopt zodra die gelijk zijn, zonder door te vergelijken op tientallen en eenheden.',
    typicalFamilies: ['GET-GROOT-VERGELIJK'],
  },
  {
    id: 'get.vergelijk-cijfers-optellen',
    label: 'Cijfers opgeteld i.p.v. positie voor positie vergelijken',
    module: 'Getalbegrip',
    description:
      'Leerling telt de cijfers van een getal op en gebruikt die som als vergelijkingswaarde (b.v. 576 → 5+7+6=18).',
    typicalFamilies: ['GET-GROOT-VERGELIJK'],
  },
  {
    id: 'get.gelijke-cijfers-gelijke-getallen',
    label: 'Dezelfde cijfers = gelijke getallen',
    module: 'Getalbegrip',
    description:
      'Leerling denkt dat getallen met dezelfde cijfers (in willekeurige volgorde) gelijk zijn, en negeert dus positie/plaatswaarde.',
    typicalFamilies: ['GET-GROOT-VERGELIJK'],
  },
  {
    id: 'get.wetenschap-exponent-min',
    label: 'Exponent te laag genomen bij wetenschappelijke notatie',
    module: 'Getalbegrip',
    description:
      'Leerling neemt de exponent één of meer te laag bij het omzetten naar wetenschappelijke notatie (telt het aantal nullen verkeerd).',
    typicalFamilies: ['GET-WETENSCHAPPELIJK', 'GET-WETENSCHAP-REKEN'],
  },
  {
    id: 'get.wetenschap-exponent-plus',
    label: 'Exponent te hoog genomen bij wetenschappelijke notatie',
    module: 'Getalbegrip',
    description:
      'Leerling neemt de exponent één of meer te hoog bij het omzetten naar wetenschappelijke notatie.',
    typicalFamilies: ['GET-WETENSCHAPPELIJK', 'GET-WETENSCHAP-REKEN'],
  },
  {
    id: 'get.wetenschap-additie',
    label: 'Telt coëfficiënt en exponent op in plaats van vermenigvuldigen',
    module: 'Getalbegrip',
    description:
      'Leerling telt de coëfficiënt en 10^n bij elkaar op in plaats van te vermenigvuldigen (bv. 3 × 10⁴ = 3 + 10000 = 10003).',
    typicalFamilies: ['GET-WETENSCHAPPELIJK', 'GET-WETENSCHAP-REKEN'],
  },
  {
    id: 'get.wetenschap-exponent-optellen',
    label: 'Exponenten opgeteld bij vermenigvuldigen — fout toegepast',
    module: 'Getalbegrip',
    description:
      'Leerling past de regel "exponenten optellen" verkeerd toe (bv. vergeet bij delen ze af te trekken, of telt op bij optellen van termen).',
    typicalFamilies: ['GET-WETENSCHAP-REKEN'],
  },
  {
    id: 'get.wetenschap-coefficient-keer',
    label: 'Coëfficiënten vermenigvuldigd zonder exponenten te combineren',
    module: 'Getalbegrip',
    description:
      'Leerling vermenigvuldigt alleen de coëfficiënten en kopieert de exponent in plaats van exponenten op te tellen.',
    typicalFamilies: ['GET-WETENSCHAP-REKEN'],
  },
  {
    id: 'get.wetenschap-niet-uitgerekend',
    label: 'Antwoord niet uitgerekend — laat als losse bewerking staan',
    module: 'Getalbegrip',
    description:
      'Leerling laat het antwoord als losse bewerking staan (bv. "3 × 10⁴ + 2 × 10⁴") in plaats van het uit te rekenen.',
    typicalFamilies: ['GET-WETENSCHAP-REKEN', 'GET-WETENSCHAPPELIJK'],
  },
  {
    id: 'get.wetenschap-exponent-telfout',
    label: 'Verkeerd aantal verschuivingen geteld bij exponent',
    module: 'Getalbegrip',
    description:
      'Leerling telt het aantal komma-verschuivingen of nullen verkeerd bij het bepalen van de exponent.',
    typicalFamilies: ['GET-WETENSCHAPPELIJK', 'GET-WETENSCHAP-REKEN'],
  },
  {
    id: 'get.wetenschap-niet-genormaliseerd',
    label: 'Coëfficiënt niet tussen 1 en 10',
    module: 'Getalbegrip',
    description:
      'Leerling geeft een coëfficiënt die niet voldoet aan 1 ≤ a < 10 (bv. 23 × 10³ of 0,5 × 10⁴).',
    typicalFamilies: ['GET-WETENSCHAPPELIJK', 'GET-WETENSCHAP-REKEN'],
  },
  {
    id: 'get.wetenschap-exponent-keer',
    label: 'Exponenten vermenigvuldigd bij vermenigvuldigen — fout',
    module: 'Getalbegrip',
    description:
      'Leerling vermenigvuldigt exponenten i.p.v. ze op te tellen bij vermenigvuldigen van machten van 10.',
    typicalFamilies: ['GET-WETENSCHAP-REKEN'],
  },
  {
    id: 'get.wetenschap-coefficient-plus',
    label: 'Coëfficiënten opgeteld bij vermenigvuldigen',
    module: 'Getalbegrip',
    description:
      'Leerling telt de coëfficiënten op in plaats van ze te vermenigvuldigen bij wetenschappelijke notatie.',
    typicalFamilies: ['GET-WETENSCHAP-REKEN'],
  },
  {
    id: 'get.wetenschap-exponent-delen',
    label: 'Exponenten verkeerd behandeld bij delen',
    module: 'Getalbegrip',
    description:
      'Leerling trekt exponenten niet af bij delen, of trekt in de verkeerde volgorde af.',
    typicalFamilies: ['GET-WETENSCHAP-REKEN'],
  },
  {
    id: 'get.wetenschap-coefficient-min',
    label: 'Coëfficiënten afgetrokken in plaats van gedeeld',
    module: 'Getalbegrip',
    description:
      'Leerling trekt de coëfficiënten van elkaar af in plaats van ze te delen bij wetenschappelijke notatie.',
    typicalFamilies: ['GET-WETENSCHAP-REKEN'],
  },
  {
    id: 'get.wetenschap-coefficient-fout',
    label: 'Coëfficiënt verkeerd bepaald',
    module: 'Getalbegrip',
    description:
      'Leerling neemt een verkeerde coëfficiënt bij omzetting naar wetenschappelijke notatie (cijfers verschoven of foutief afgelezen).',
    typicalFamilies: ['GET-WETENSCHAPPELIJK', 'GET-WETENSCHAP-REKEN'],
  },
  {
    id: 'get.wetenschap-coefficient-naast',
    label: 'Naastliggende coëfficiënt gekozen',
    module: 'Getalbegrip',
    description:
      'Leerling kiest een coëfficiënt die qua waarde dichtbij ligt maar net niet klopt (off-by-one of nul verkeerd geplaatst).',
    typicalFamilies: ['GET-WETENSCHAPPELIJK', 'GET-WETENSCHAP-REKEN'],
  },
  {
    id: 'get.wetenschap-coefficient-dominant',
    label: 'Coëfficiënt als dominante waarde gelezen',
    module: 'Getalbegrip',
    description:
      'Leerling baseert de vergelijking of berekening alleen op de coëfficiënt en negeert de exponent volledig.',
    typicalFamilies: ['GET-WETENSCHAPPELIJK', 'GET-WETENSCHAP-REKEN'],
  },
  {
    id: 'get.wetenschap-gelijk-aangenomen',
    label: 'Twee notaties als gelijk aangenomen',
    module: 'Getalbegrip',
    description:
      'Leerling beschouwt twee verschillende wetenschappelijke notaties als gelijk zonder te controleren of de coëfficiënt × 10^exponent dezelfde waarde oplevert.',
    typicalFamilies: ['GET-WETENSCHAPPELIJK', 'GET-WETENSCHAP-REKEN'],
  },
]
